import React from 'react'
import { CancelProductUIStore } from '../stores'

export const CancelProductContext = React.createContext({
  uiStore: new CancelProductUIStore()
})
